import React, { useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import BaseInput from './BaseInput';
import BaseInputProps from './BaseInputProps';

type ConditionalInputProps<T extends boolean> = T extends true
  ? JSX.IntrinsicElements["textarea"]
  : JSX.IntrinsicElements["input"];

export interface TextInputProps<T extends boolean = false> extends BaseInputProps {
  multi?: T;
  validation?: BaseInputProps["validation"] & {
    regex?: RegExp
    regexError?: string
  }
  inputProps?: ConditionalInputProps<T>;
}

export default function TextInput <T extends boolean>({ multi, inputProps, ...baseProps }: TextInputProps<T>) {
  const { name, validation } = baseProps;

  // const { register, setError, formState } = useFormContext();
  const { field: { value } } = useController({ name });
  // const [isFocused, setIsFocused] = useState(false);

  // useEffect(() => {
  //   if (formState.submitCount === 0) return; 

  //   if (props.validation?.regex && !props.validation.regex.test(value)) {
  //     setError(name, {
  //       type: "",
  //       message: props.validation.regexError || "Invalid input"
  //     });
  //   }
  // }, [formState.submitCount, name, props.validation, setError, value]);

  const { register } = useFormContext();
  const [isFocused, setIsFocused] = useState(false);

  if (validation?.regex) {
    register(name, { pattern: { value: validation.regex, message: validation.regexError ?? 'Invalid input' } });
  }

  let label = baseProps.label;
  if (validation?.maxLength) {
    label = `${label} (${value?.length ?? 0} / ${validation.maxLength})`;
  }

  return (
    <BaseInput isFocused={isFocused} {...{ ...baseProps, label }}>
      {multi ? (
        <textarea
          {...register(name)}
          id={name}
          className="mt-2 text-base p-2 block w-full rounded-md border-0 text-limed-spruce-800 shadow-sm ring-1 ring-inset ring-porcelain-300 placeholder:text-porcelain-400 focus:ring-2 focus:ring-inset focus:ring-bondi-blue-600"
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          {...inputProps as JSX.IntrinsicElements["textarea"]}
        />
      ) : (
        <input
          {...register(name)}
          id={name}
          className="mt-2 text-base p-2 block w-full rounded-md border-0 text-limed-spruce-800 shadow-sm ring-1 ring-inset ring-porcelain-300 placeholder:text-porcelain-400 focus:ring-2 focus:ring-inset focus:ring-bondi-blue-600"
          type="text"
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          {...inputProps as JSX.IntrinsicElements["input"]}
        />
      )}
    </BaseInput>
  );
}

export const EmailInput = (props: TextInputProps<false>) => {
  const { register } = useFormContext();
  
  const emailRegex = /^\S+@\S+\.\S+$/;
  register(props.name, { pattern: { value: emailRegex, message: 'Invalid email address' } });

  return <TextInput {...props} />;
};
